export default __webpack_public_path__ + "static/bipolar-444b794a6097c9398d02598f69bece66.webp";